import { useFliptBoolean } from '@flipt-io/flipt-client-react';

export function FeatureFlag({ flagKey, entityId, children }) {
  const isEnabled = useFliptBoolean(flagKey, false, entityId, {
    // additional context (optional)
  });

  return isEnabled ? children : null;
}
